const PlayIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25.458" height="25.458" viewBox="0 0 25.458 25.458">
      <path d="M25.458 0H0v25.458h25.458z" fill={'none'}/>
      <path d="M14.608 4A10.608 10.608 0 1 1 4 14.608 10.6 10.6 0 0 1 14.608 4zm2.122 15.381V9.834l-6.365 4.773z" transform="translate(-1.878 -1.878)" fill={'currentColor'}/>
    </svg>
  );
};

export default PlayIcon;
